import type { GenericTranslationsObject } from '@payloadcms/translations'

export const sk: GenericTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-seo': {
    almostThere: 'Takmer hotovo',
    autoGenerate: 'Automaticky generovať',
    bestPractices: 'najlepšie postupy',
    characterCount: '{{current}}/{{minLength}}-{{maxLength}} znakov, ',
    charactersLeftOver: '{{characters}} znakov navyše',
    charactersToGo: 'Ešte {{characters}} znakov',
    charactersTooMany: '{{characters}} znakov navyše',
    checksPassing: '{{current}}/{{max}} kontrol prešlo',
    good: 'Dobre',
    imageAutoGenerationTip: 'Automatické generovanie načíta vybraný hlavný obrázok.',
    lengthTipDescription:
      'Tento text by mal mať medzi {{minLength}} a {{maxLength}} znakmi. Ak potrebujete pomoc s písaním kvalitných meta popisov, pozrite si ',
    lengthTipTitle:
      'Tento text by mal mať medzi {{minLength}} a {{maxLength}} znakmi. Ak potrebujete pomoc s písaním kvalitných meta nadpisov, pozrite si ',
    missing: 'Chýba',
    noImage: 'Žiadny obrázok',
    preview: 'Náhľad',
    previewDescription:
      'Presné výsledky vyhľadávania sa môžu líšiť v závislosti od obsahu a relevantnosti vyhľadávania.',
    tooLong: 'Príliš dlhé',
    tooShort: 'Príliš krátke',
  },
}
